module.exports = __webpack_public_path__ + "img/xseed.4a647fb8.png";